import React from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'bootstrap.native'

import { AVAILABLE, OCCUPIED, default as ALL_STATUS } from '../constants/status'
import { addFilter, deleteFilter } from '../actions'
import { getUser } from '../selectors'

import Icon from '../components/Icon'

import '../styles/subscriber-filter'

class SubscriberFilter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
        this.saveFilter = this.saveFilter.bind(this)
    }

    getFilter() {
        return this.props.filter || this.state
    }

    initializeDropdown(element, persist) {
        if (element && !element.Dropdown) {
            new Dropdown(element, persist)
        }
    }

    resetFilter(newFilter) {
        const filter = newFilter && { ...newFilter }
        if (this.props.filter) {
            this.onFilterChanged(filter)
        } else {
            this.setState(filter, () => this.onFilterChanged(this.state))
        }
    }

    onFilterChanged(filter) {
        if (this.allStatusCheckbox) {
            this.allStatusCheckbox.indeterminate = filter && filter.status && filter.status.length > 0 && filter.status.length < ALL_STATUS.length
        }
        if (this.allUnitsCheckbox) {
            this.allUnitsCheckbox.indeterminate = filter && filter.units && filter.units.length > 0 && filter.status.length < this.props.config.units.length
        }
        if (this.props.onFilterChanged) {
            this.props.onFilterChanged(filter)
        }
    }

    changeFilter(filter) {
        if (this.props.filter) {
            this.onFilterChanged(Object.assign({}, this.props.filter, filter))
        } else {
            this.setState(filter, this.onFilterChanged)
        }
    }

    unitFilter(param) {
        const { units } = this.getFilter()
        if (typeof param === 'string' || typeof param === 'number') {
            return !units || units.find(unit => unit == param) != null
        }
        const ALL_UNITS = this.props.config.units.map(unit => unit.key)
        if (param === this.allUnitsCheckbox) {
            if (units && units.length < ALL_UNITS.length) {
                this.changeFilter({ units: null })
            } else {
                this.changeFilter({ units: [] })
            }
        } else {
            const toAdd = Object.keys(param).filter(key => param[key] && !(units && units.indexOf(key) >= 0))
            const unitsFilter = (units || ALL_UNITS).filter(key => param[key] !== false).concat(toAdd)
            this.changeFilter({ units: unitsFilter })
        }
    }

    statusFilter(param) {
        const { status } = this.getFilter()
        if (typeof param === 'string' || typeof param === 'number') {
            return status && status.find(s => s == param) != null
        }
        if (param === this.allStatusCheckbox) {
            const selectAll = status.length < ALL_STATUS.length
            param = ALL_STATUS.reduce((status, key) => Object.assign(status, { [key]: selectAll }), {})
        }
        const toAdd = Object.keys(param).filter(key => param[key])
        const statusFilter = status ? status.filter(key => param[key] !== false).concat(toAdd) : toAdd
        this.changeFilter({ status: statusFilter })
    }

    saveFilter() {
        const name = window.prompt('Save current filter as:')
        if (name) {
            this.props.addFilter(name, { ...this.getFilter() })
        }
    }

    render() {
        const { config, user, className, filters, showStatus = true } = this.props
        const { site, status, units, searchText } = this.getFilter()
        const siteDropdownText = site ? config.sites.filter(s => s.key === site).map(s => s.name) || site : 'All'
        const allUnits = units == null || units.length === config.units.length
        const unitsFilterSelectionText = allUnits ? 'All' : units.length > 0 ? units.map(key => config.units.find(u => u.key == key) || key).map(u => u.name || u).join(',') : 'None'
        const statusFilterSelectionText = status && status.length > 0 ? status.length < ALL_STATUS.length ? status.join(',') : 'All' : 'None'
        const checkedIconProps = { prefix: 'fa', icon: 'check-square-o' }
        const uncheckedIconProps = { prefix: 'fa', icon: 'square-o' }
        const indeterminateIconProps = { prefix: 'fa', icon: 'square' }
        return (
            <div className={`subscriber-filter ${className}`}>
                <div className="search-text">
                    <input type="text" className="form-control" placeholder="Search..." value={searchText || ''} onChange={e => this.changeFilter({ searchText: e.target.value })} />
                </div>
                <div className="site dropdown">
                    <button type="button" className="btn btn-default dropdown-toggle" ref={e => this.initializeDropdown(e)}>
                        Site <span className="small">[{siteDropdownText}]</span>&nbsp;&nbsp;<span className="caret"></span>
                    </button>
                    <ul className="dropdown-menu">
                        <li><a href="#" onClick={() => this.changeFilter({ site: null })}>All</a></li>
                        <li role="separator" className="divider"></li>
                        {config.sites.sort((x, y) => x.name.localeCompare(y.name)).map(site => {
                            const key = site.key || site
                            const name = site.name || site
                            return <li key={key}>
                                <a href="#" onClick={() => this.changeFilter({ site: key })} tabIndex="-1">{name}</a>
                            </li>
                        })}
                    </ul>
                </div>
                <div className="units dropdown">
                    <button type="button" className="btn btn-default dropdown-toggle" ref={e => { if(config.units.length) { this.initializeDropdown(e, true) } }}>
                        Units <span className="small">[{unitsFilterSelectionText}]</span>&nbsp;&nbsp;<span className="caret"></span>
                    </button>
                    <ul className="dropdown-menu">
                        <li>
                            <a href="#" ref={e => this.allUnitsCheckbox = e} onClick={e => { e.preventDefault(); this.unitFilter(e.currentTarget); }}>
                                <Icon {...(allUnits ? checkedIconProps : units && units.length ? indeterminateIconProps : uncheckedIconProps) } />
                                All
                            </a>
                        </li>
                        <li role="separator" className="divider"></li>
                        {config.units.map(unit => {
                            const isChecked = this.unitFilter(unit.key)
                            return (
                                <li key={unit.key}>
                                    <a href="#" tabIndex="-1" onClick={e => { e.preventDefault(); this.unitFilter({ [unit.key]: !isChecked }); }}>
                                        <Icon {...(isChecked ? checkedIconProps : uncheckedIconProps) } />
                                        {unit.name}
                                    </a>
                                </li>
                            )
                        })}
                    </ul>
                </div>
                {showStatus &&
                    <div className="status dropdown">
                        <button type="button" className="btn btn-default dropdown-toggle" ref={e => this.initializeDropdown(e, true)}>
                            Status <span className="small">[{statusFilterSelectionText}]</span>&nbsp;&nbsp;<span className="caret"></span>
                        </button>
                        <ul className="dropdown-menu">
                            <li>
                                <a href="#" ref={e => this.allStatusCheckbox = e} onClick={e => { e.preventDefault(); this.statusFilter(e.currentTarget); }}>
                                    <Icon {...((status && status.length) > 0 ? status.length < ALL_STATUS.length ? indeterminateIconProps : checkedIconProps : uncheckedIconProps) } />All
                            </a>
                            </li>
                            <li role="separator" className="divider"></li>
                            {ALL_STATUS.map(status => {
                                const isChecked = this.statusFilter(status)
                                return (
                                    <li key={status}>
                                        <a href="#" tabIndex="-1" onClick={e => { e.preventDefault(); this.statusFilter({ [status]: !isChecked }); }}>
                                            <Icon {...(isChecked ? checkedIconProps : uncheckedIconProps) } />
                                            {status}
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                }

                <button onClick={e => this.resetFilter()} className="btn btn-default reset">Reset</button>
                <button className="btn btn-default" onClick={this.saveFilter}><Icon icon="floppy-disk" title="save" /></button>
                {filters && filters.length > 0 &&
                    <div className="filters dropdown">
                        <button type="button" className="btn btn-default dropdown-toggle" ref={e => this.initializeDropdown(e)}>
                            Saved filters&nbsp;<span className="caret"></span>
                        </button>
                        <ul className="dropdown-menu">
                            {filters.map(filter => (
                                <li key={filter.name}>
                                    <a href="#" tabIndex="-1" onClick={() => this.resetFilter(filter.filter)}>
                                        {filter.name}
                                        <button onClick={() => this.props.deleteFilter(filter.name)}><Icon icon="trash" title="delete" /></button>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        config: state.config,
        filters: state.preferences.filters,
        user: getUser(state)
    }
}

export default connect(mapStateToProps, { addFilter, deleteFilter })(SubscriberFilter)



// WEBPACK FOOTER //
// ./containers/SubscriberFilter.jsx